import * as yup from 'common/yup';

export const BackupRequest = yup.object({
   backupDirPath: yup.string(),
   backupFilename: yup.string(),
   overwrite: yup.bool(),
   transactionNames: yup.array().of(yup.string()).nullable(),
   removePasswords: yup.bool(),
});
export type IBackupRequest = yup.InferType<typeof BackupRequest>;
